export const LOGO_APPLE_STORE = 'LOGO_APPLE_STORE'
export const LOGO_GOOGLE_STORE = 'LOGO_GOOGLE_STORE'
